var map = {
	"./legalreviewTailwindUI/legalnewDeal": [
		13099,
		1192,
		2019,
		9199,
		2954,
		5786,
		5454,
		4201,
		5049,
		9163,
		1263,
		7417,
		9960,
		1207,
		8256
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 10996;
module.exports = webpackAsyncContext;